var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-primary"},[_c('i',{staticClass:"fa fa-edit fa-lg icon-button mr-1",attrs:{"title":"Atualizar"},on:{"click":function($event){$event.stopPropagation();return _vm.atualizarPleito()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }